import type { RfiDraft, RfiDraftUpdatePayload } from '@/app/types/rfi-draft';
import { ApiClient } from './client';

export class RfiDraftsClient extends ApiClient {
  async getRfiDraft(projectId: number, takeoffId: number, issueId: number): Promise<RfiDraft> {
    return this._get<RfiDraft>(
      `projects/${projectId}/takeoffs/${takeoffId}/issues/${issueId}/rfi-draft/`,
    );
  }

  async createRfiDraft(projectId: number, takeoffId: number, issueId: number): Promise<RfiDraft> {
    return this._post<RfiDraft>(
      `projects/${projectId}/takeoffs/${takeoffId}/issues/${issueId}/rfi-draft/`,
    );
  }

  async updateRfiDraft(
    projectId: number,
    takeoffId: number,
    issueId: number,
    data: RfiDraftUpdatePayload,
  ): Promise<RfiDraft> {
    return this._patch<RfiDraft>(
      `projects/${projectId}/takeoffs/${takeoffId}/issues/${issueId}/rfi-draft/`,
      data,
    );
  }
}
